import script from "./configTips.vue?vue&type=script&setup=true&lang=js"
export * from "./configTips.vue?vue&type=script&setup=true&lang=js"

import "./configTips.vue?vue&type=style&index=0&id=aca4d78a&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aca4d78a"]])

export default __exports__